import React from "react";
import PropTypes from "prop-types";
import * as styles from "./StarRating.module.scss";
import { Icon } from "../Icons";

const StarRating = ({ rating }) => (
	<div className={styles.rating}>
		{[...Array(Math.floor(rating))].map((star, i) => (
			// eslint-disable-next-line react/no-array-index-key
			<Icon name="rating-solid" key={i} />
		))}
		{rating % 1 !== 0 && <Icon name="rating-partial" />}
		{Math.round(rating) < 5 &&
			[...Array(5 - Math.round(rating))].map((star, i) => (
				// eslint-disable-next-line react/no-array-index-key
				<Icon name="rating-outline" key={i} />
			))}
		<span className={styles.ratingText}>{rating % 1 === 0.5 ? rating : `${rating}.0`}</span>
	</div>
);

StarRating.propTypes = {
	rating: PropTypes.number.isRequired,
};

export { StarRating };
